import Service from './Service';
/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class RelatorioReembolsoService extends Service {
  async consultarRelatorioReembolso (filter) {
    let reembolsos = [];
    let result = await this.getRelatorioReembolsoApi().consultarRelatorioReembolso(filter);
    reembolsos = result;
    return reembolsos;
  }
  async consultarRelatorioReembolsoExport (filter) {
    let reembolsos = [];
    let result = await this.getRelatorioReembolsoApi().consultarRelatorioReembolso(filter);
    result.map(res => {
      const { codigo, nome, seqFolha, codRubrica, desRubrica, valReembolso } = res;
      reembolsos.push(Object.values({ codigo, nome, seqFolha, codRubrica, desRubrica, valReembolso }));
    });
    return reembolsos;
  }
}
export default RelatorioReembolsoService;
